// extracted by mini-css-extract-plugin
module.exports = {"hub":"ChildPagesHub_hub__ZhxNi","grid":"ChildPagesHub_grid__BfLId"};